import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d99975e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row display-property" }
const _hoisted_2 = { class: "col iodine-label display-property-label" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col display-property-value" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayProperty',
  props: {
  label: String,
  value: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.value), 1)
    ])
  ], 64))
}
}

})